import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useT } from "@/context/LangContext";

export default function PaymentCancel() {
  const t = useT();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="card-flat p-12 text-center max-w-md">
        <XCircle className="text-red-500 mx-auto" size={56} />
        <h1 className="font-display text-3xl font-black mt-6">{t("pay.cancel.title")}</h1>
        <p className="text-[var(--ink-soft)] mt-3">{t("pay.cancel.desc")}</p>
        <Link to="/produits" className="btn-primary mt-8 inline-flex" data-testid="back-products">{t("pay.back")}</Link>
      </div>
    </div>
  );
}
